const wl = window.location;
const myURL = `${wl.protocol}//${wl.host}`;

export default myURL;
